import { EcommerceAPI } from "../Client";

export const getGstApi = async (payload) => {
  try {
    return await EcommerceAPI.get("/gst", {
      params: { id: payload?.id },
    });
  } catch (error) {
    throw error;
  }
};

export const updateGstApi = async (payload) => {
  try {
    return await EcommerceAPI.put("/gst", payload);
  } catch (error) {
    throw error;
  }
};

export const postGstApi = async (payload) => {
  try {
    const { productId, serviceId, ...body } = payload || {};

    return await EcommerceAPI.post("/gst", body, {
      params: { productId, serviceId },
    });
  } catch (error) {
    throw error;
  }
};

export const deleteGstApi = async (payload) => {
  try {
    return await EcommerceAPI.delete("/gst", {
      params: { id: payload?.id },
    });
  } catch (error) {
    throw error;
  }
};

export const getGstsApi = async (payload) => {
  try {
    return await EcommerceAPI.get("/gsts", {
      params: {
        page: payload?.page ?? 0,
        size: payload?.size ?? 10,
        sortBy: payload?.sortBy || "createdOn",
        sortDir: payload?.sortDir || "desc",
        onlyProductGst: payload?.onlyProductGst ?? 0,
        onlyServiceGst: payload?.onlyServiceGst ?? 0,
      },
    });
  } catch (error) {
    throw error;
  }
};
